import { KPIUnit } from './types';

export interface ManualMetricDefinition {
  key: string;
  label: string;
  section: 'training' | 'vanta' | 'security_incidents' | 'vendor_assessments';
  sectionLabel: string;
  unit: KPIUnit;
}

export type MetricGoal = 'higher' | 'lower';

// Trend direction has different business meaning per KPI. Keeping this map
// explicit prevents an increase in vulnerabilities from being shown as good.
export const metricGoals: Record<string, MetricGoal> = {
  ca_new_vulnerabilities: 'lower',
  ca_fixed_vulnerabilities: 'higher',
  ca_eol_software: 'lower',
  ca_eol_operating_systems: 'lower',
  ca_avg_remediation_days: 'lower',
  ca_workstations_scanned: 'higher',
  ca_servers_scanned: 'higher',
  wa_high_severity_findings: 'lower',
  wa_avg_remediation_days: 'lower',
  wa_web_apps_scanned: 'higher',
  endpoint_high_severity_findings: 'lower',
  endpoint_avg_remediation_days: 'lower',
  endpoint_devices: 'higher',
  sast_high_severity_findings: 'lower',
  sast_avg_remediation_days: 'lower',
  sast_repositories_scanned: 'higher',
  training_percent_trained: 'higher',
  training_overdue_users: 'lower',
  training_overdue_signoff_users: 'lower',
  training_due_within_30_days: 'lower',
  phishing_click_rate_percent: 'lower',
  phishing_clickers: 'lower',
  vanta_overdue_evidence_items: 'lower',
  vanta_automated_tests_passing_percent: 'higher',
  vanta_documents_passing_percent: 'higher',
  vanta_control_completion_percent: 'higher',
  logical_security_incidents: 'lower',
  physical_security_incidents: 'lower',
  reportable_security_incidents: 'lower',
  vendor_assessments_completed: 'higher',
};

export const manualMetricDefinitions: ManualMetricDefinition[] = [
  {
    key: 'training_percent_trained',
    label: 'Trained',
    section: 'training',
    sectionLabel: 'Training',
    unit: 'percent',
  },
  {
    key: 'training_overdue_users',
    label: 'Users with overdue training',
    section: 'training',
    sectionLabel: 'Training',
    unit: 'count',
  },
  {
    key: 'training_overdue_signoff_users',
    label: 'Users with overdue sign-off',
    section: 'training',
    sectionLabel: 'Training',
    unit: 'count',
  },
  {
    key: 'training_due_within_30_days',
    label: 'Training or sign-off due within 30 days',
    section: 'training',
    sectionLabel: 'Training',
    unit: 'count',
  },
  {
    key: 'phishing_click_rate_percent',
    label: 'Phishing click rate',
    section: 'training',
    sectionLabel: 'Training',
    unit: 'percent',
  },
  {
    key: 'phishing_clickers',
    label: 'Phishing clickers',
    section: 'training',
    sectionLabel: 'Training',
    unit: 'count',
  },
  {
    key: 'vanta_overdue_evidence_items',
    label: 'Overdue evidence items',
    section: 'vanta',
    sectionLabel: 'Vanta',
    unit: 'count',
  },
  {
    key: 'vanta_automated_tests_passing_percent',
    label: 'Automated tests passing',
    section: 'vanta',
    sectionLabel: 'Vanta',
    unit: 'percent',
  },
  {
    key: 'vanta_documents_passing_percent',
    label: 'Documents passing',
    section: 'vanta',
    sectionLabel: 'Vanta',
    unit: 'percent',
  },
  {
    key: 'vanta_control_completion_percent',
    label: 'Control completion',
    section: 'vanta',
    sectionLabel: 'Vanta',
    unit: 'percent',
  },
  {
    key: 'logical_security_incidents',
    label: 'Logical security incidents',
    section: 'security_incidents',
    sectionLabel: 'Security Incidents',
    unit: 'count',
  },
  {
    key: 'physical_security_incidents',
    label: 'Physical security incidents',
    section: 'security_incidents',
    sectionLabel: 'Security Incidents',
    unit: 'count',
  },
  {
    key: 'reportable_security_incidents',
    label: 'Reportable security incidents',
    section: 'security_incidents',
    sectionLabel: 'Security Incidents',
    unit: 'count',
  },
  {
    key: 'vendor_assessments_completed',
    label: 'Vendor assessments completed',
    section: 'vendor_assessments',
    sectionLabel: 'Vendor Assessments',
    unit: 'count',
  },
];
